// extracted by mini-css-extract-plugin
export default {"root":"_2Yaot","muroIcon":"_1sUc7","newIcon":"_2LDPB"};